module.exports = __webpack_public_path__ + "img/icon_close.7dde47a3.svg";